import React, {Component} from 'react'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import './PotentialClient.scss'
import { Table, PanelWrapper } from 'components/UI'
import locale from './locale'
import tableSettings from "./table-settings";
import studentFields from './table-fields';
import TagsField from './TagsField';
import PotentialClientModal from 'template/Modals/PotentialClient'
import {fetchClientList, deleteClientTag, editClientTag} from './ducks'
import searchByTag from 'controllers/client/searchByTag'
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import __R, {userCan} from 'containers/__R';
import Loading from 'components/UI/Loading';
import { MenuItem, Dropdown } from 'react-bootstrap'
import FilterBy from 'template/FilterBy';

const mapStateToProps = (state) => ({
  clientList: state.clientList
})

const mapDispatchToProps = (dispatch) => {
	return {
    fetchClientList: (obj) => dispatch(fetchClientList(obj)),
    deleteClientTag: (index, tagId, tagName) => dispatch(deleteClientTag(index, tagId, tagName)),
    editClientTag: (index, tagId, oldTagName, tagName, callback) => dispatch(editClientTag(index, tagId, oldTagName, tagName, callback)),
	};
};
const FILTERS = ['text:searchKeyword'];
const FILTER_OPTIONS = {
  'text:searchKeyword': {
    placeholder: __('Search contacts', locale),
    valueMinLength: 2,
  }
}
class PotentialClient extends Component{
  constructor(props){
    super(props)

    this.state = {
      list: [],
      tag_id_list: [],
      options: [],
      selectedOption: '',
      pagination: {
        itemsCountPerPage: 25,
        activePage: 1,
        totalItemsCount: 0,
      },
      keyword: '',
      filterData: {}
    }

    this.onTagChange = this.onTagChange.bind(this)
    this.fetchClientList = this.fetchClientList.bind(this);
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onFilterChange = this.onFilterChange.bind(this);
  }

  componentWillMount(){
    const schoolId = localStorage.getItem('schoolId')
    const {tag_id_list, pagination} = this.state
    const {activePage, itemsCountPerPage} = pagination;
    if(tag_id_list.length == 0){
      this.fetchClientList();
    } else {
      searchByTag(schoolId, {student_state: 'not_transfer', tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage})
      .then((res) => { 
        this.setState({
          list: res.result_list,
          pagination: {
            itemsCountPerPage: itemsCountPerPage,
            activePage: res.current_page_number,
            totalItemsCount: res.total_amount,
          }
        })
      })
    }
  }

  componentWillReceiveProps({clientList}){
    if(this.state.list !== clientList.list){
      this.setState({list: clientList.list, pagination: clientList.pagination})
    }
    if(this.state.pagination !== clientList.pagination){
      this.setState({pagination: clientList.pagination})
    }
  }

  fetchClientList() {
    const { pagination, keyword } = this.state;
    const {activePage, itemsCountPerPage} = pagination;
    const schoolId = localStorage.getItem('schoolId');

    this.props.fetchClientList({
      schoolId,
      student_state: 'notTransfer',
    	amount_per_page: itemsCountPerPage,
      page_number: activePage,
      keyword: keyword
    })
  }
	onFilterChange({ filterData }){
    const schoolId = localStorage.getItem('schoolId')
    const {tag_id_list, pagination} = this.state
    const {itemsCountPerPage} = pagination;
        
    this.setState((prevState)=>({
      pagination: {...prevState.pagination, activePage: 1},
      filterData,
      keyword: filterData['searchKeyword'],
      tag_id_list: []
    }),
      ()=>{
        this.fetchClientList();
      }
    )
	}

  onTagChange(event, tagId){
    const schoolId = localStorage.getItem('schoolId')
    const {tag_id_list, pagination} = this.state
    const {activePage, itemsCountPerPage} = pagination;
    this.setState({
      filterData: {
        ...this.state.filterData,
        searchKeyword: '',
      },
      keyword: ''
    })
    if(event.target.checked){
      this.setState({
        tag_id_list: tag_id_list.concat([tagId])
      }, () => {
        searchByTag(schoolId, {student_state: 'not_transfer', tag_id_list: this.state.tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage})
        .then((res) => { 
          this.setState({
            list: res.result_list,           
            pagination: {
              itemsCountPerPage: itemsCountPerPage,
              activePage: res.current_page_number,
              totalItemsCount: res.total_amount,
            }
          })
        })
      })
    } else {
      this.setState({
        tag_id_list: tag_id_list.filter(function(val) {return val!==tagId})
      }, () => {
        if(this.state.tag_id_list.length == 0){
          this.fetchClientList();
        } else {
          searchByTag(schoolId, {student_state: 'not_transfer', tag_id_list: this.state.tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage})
          .then((res) => { 
            this.setState({
            list: res.result_list,
            pagination: {
              itemsCountPerPage: itemsCountPerPage,
              activePage: res.current_page_number,
              totalItemsCount: res.total_amount,
            }
            })
          })
        }
      })
    }
  }

  onItemsCountPerPageChange(itemsCountPerPage){
    const {tag_id_list, pagination}=this.state;
    const {activePage} = pagination;
    let schoolId = localStorage.getItem('schoolId')

    this.setState((prevState)=>({
      pagination: {...prevState.pagination, itemsCountPerPage},
    }),()=>{
      if(tag_id_list.length === 0){
        this.fetchClientList();
      }else {
        searchByTag(schoolId, {student_state: 'not_transfer', tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage})
        .then((res) => { 
          this.setState({
          list: res.result_list,
          pagination: {
            itemsCountPerPage: itemsCountPerPage,
            activePage: res.current_page_number,
            totalItemsCount: res.total_amount,
          }
          })
        })
      }
    })
  }

  onPageChange(activePage) {
    const {pagination, tag_id_list} = this.state;
    const {itemsCountPerPage} = pagination;
    const schoolId = localStorage.getItem('schoolId')

    if (activePage !== pagination.activePage) {
      this.setState((prevState)=>({
        pagination: {...prevState.pagination, activePage},
      }),()=>{
        if(tag_id_list.length === 0){
          this.fetchClientList();
        }else {
          searchByTag(schoolId, {student_state: 'not_transfer', tag_id_list, amount_per_page: itemsCountPerPage, page_number: activePage})
          .then((res) => { 
            this.setState({
            list: res.result_list,
            pagination: {
              itemsCountPerPage: itemsCountPerPage,
              activePage: res.current_page_number,
              totalItemsCount: res.total_amount,
            }
            })
          })
        }
      })
    }
  }

  render(){
    const {clientList} = this.props;
    const {tag_list, hasPermission, school_has_contact, fetching} = clientList
    const {list, tag_id_list, pagination, filterData} = this.state;
    const content = onBoardingContents || {};
    this.studentFields = studentFields.call(this);
    this.tableSettings = tableSettings.call(this);

    return(
      <PanelWrapper className='potential-client-container'>
        <div className='pc-header'>
          <div className='pc-title'>{__('Contacts', locale)}</div>
          <div className='pc-settings'>
            <FilterBy
              filterData={filterData}
              filters={FILTERS}
              options={FILTER_OPTIONS}
              onChange={this.onFilterChange} />
            <__R can="create_contact" by="disable">
              <button className='btn btn-primary pull-right' 
                onClick={() => {
                  PotentialClientModal({type: 'create'})
                    .then((res)=>{
                      this.fetchClientList();
                    })
                }}>
                <i className='fa icon-plus'></i>
                {__('New Contact', locale)}
              </button>
            </__R>
            <Dropdown  id='setting-dropdown' className='pull-right'>
              <Dropdown.Toggle className='expand-to-right expand-to-down'>
                <i className='fa icon-cog' style={{marginRight: 5}}></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem eventKey="contact-settings" onSelect={()=>{
                  browserHistory.push('/contact-settings') 
                }} disabled={!userCan('edit_contact_custom_field')}>{__('Contact Custom Fields', locale)}</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {((school_has_contact == false && content) || hasPermission == false) && <OnBoardingNatural
          isShown={true}
          title={content.title}
          text={content.text}
          image={content.image}
          showArrow={content.showArrow}
        />}
        {(school_has_contact || !hasPermission) && <div className='row'>
          <div className='col-xs-9'>
            <Table
              data={list}
              fields={this.studentFields}
              settings={this.tableSettings}
              fetching={fetching}
              className='potential-client-table'
              settingThTitle={' '}
              settingWidth={'100px'}
              oneSettingPerRow={false}
              hideDropdownCaret={false}
              pagination={pagination}
              usePagination={true}
              onPageChange={this.onPageChange}
              onItemsCountPerPageChange={this.onItemsCountPerPageChange}
            />
          </div>
          <div className='col-xs-3'>
            <TagsField
              tagList={tag_list}
              onTagChange={this.onTagChange}
              tag_id_list={tag_id_list}
              deleteTag={this.props.deleteClientTag}
              editTag={this.props.editClientTag}
            />
          </div>
        </div>}
      </PanelWrapper>
    )
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(PotentialClient)



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/index.js